import React from 'react';

import { Typography } from '@one-thd/sui-atomic-components';

export const ShareProjectDescription = () => {
  return (
    <Typography>
      Share your entire project or specific groups with collaborators. They&apos;ll receive an email
      containing a link to access the shared information.
    </Typography>
  );
};
